let Global={
    BLOOM_SCENE:1,
    energyTotal:0,
    playCount:0,
    scoreTotal:0,
    backgroundIntensity:0.8,
    delta:1,
    envMap:null,
    roadMat:null,
    fps:60,
    imgArr:[],
    preloadImgObj:{
        preloadPromise:null
    },
    sessionId:null,
    gameOver:true,
    rank:-1,
    placed:false,
    isGyro:false,
    userCar:null,
    controlType:null,
    miniMapScene:null,
    tiltAlpha:0,
    titleDirection:1,
    leftLane:[],
    rightLane:[],
    leftLaneMesh: [],
    rightLaneMesh:[],
    cars:[],
    speedLimiters:[],
    speedIndicator:[],
    speedActivators:[],
    carPositionIndex:{

    },
    gameTry:0,
    userName:null,
    email:null,
    userRegistered:false,
    couponCode:"XXXX01976",
    soundEnabled:true,
    gameLevel:1,
    levelCompleted:false,
    gameFailed:false,
    vehicleType:null,
    level1Time:0,
    level2Time:0,
    level3Time:0,
    assets:{
        "cubemap":{
           /* "0":{
            'key':'environmentMapTexture',
                "path":[
                    'https://www.jimmysarcade.co.uk/textures/environmentMaps/0/px.png',
                    'https://www.jimmysarcade.co.uk/textures/environmentMaps/0/nx.png',
                    'https://www.jimmysarcade.co.uk/textures/environmentMaps/0/py.png',
                    'https://www.jimmysarcade.co.uk/textures/environmentMaps/0/ny.png',
                    'https://www.jimmysarcade.co.uk/textures/environmentMaps/0/pz.png',
                    'https://www.jimmysarcade.co.uk/textures/environmentMaps/0/nz.png'
                ],
                "asset":null
           } */
        },
        "glbs":{
           "skybox":{
                'key':'skybox',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/landscape/skybox.glb'
                ],
                "asset":null
            },
            "skybox2":{
                'key':'skybox2',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/landscape/skybox2.glb'
                ],
                "asset":null
            },
            "beach_road":{
                'key':'road',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/road/v2/beach_track_final_7_MERGRED.glb'
                ],
                "asset":null
            },
            "city_road":{
                'key':'road',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/road/v2/track_city_6_MERGED.glb'
                ],
                "asset":null
            },
            "mountain_road":{
                'key':'road',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/road/v2/MOUNTAIN_track_railing_footbath_colider_MERGED.glb'
                ],
                "asset":null
            },
            "mountain_road2":{
                'key':'road',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/road/v2/mountains_1_MERGED.glb'
                ],
                "asset":null
            },
            
            "Car":{
                'key':'Car',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/car.glb'
                ],
                "asset":null
            },
            "Bike":{
                'key':'Bike',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/bike.glb'
                ],
                "asset":null
            },
            "Truck":{
                'key':'Truck',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/truck.glb'
                ],
                "asset":null
            },
            /* "EVCar3":{
                'key':'EVCar3',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/EVCar3.glb'
                ],
                "asset":null
            }, */
            "AICar1":{
                'key':'AICar1',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/AI/AI1.glb'
                ],
                "asset":null
            },
            "AICar2":{
                'key':'AICar2',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/AI/AI2.glb'
                ],
                "asset":null
            },
            "AICar3":{
                'key':'AICar3',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/AI/AI3.glb'
                ],
                "asset":null
            },
            "AICar4":{
                'key':'AICar4',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/AI/AI4.glb'
                ],
                "asset":null
            },
            "AICar5":{
                'key':'AICar5',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/AI/AI5.glb'
                ],
                "asset":null
            },
            "AIBus":{
                'key':'AIBus',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/AI/AIBus.glb'
                ],
                "asset":null
            },
            "AIVan":{
                'key':'AIVan',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/cars/AI/AIVan.glb'
                ],
                "asset":null
            },
           
            "startingLine":{
                'key':'startingLine',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/start.glb'
                ],
                "asset":null
            },
            "finishLine":{
                'key':'finishLine',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/finish.glb'
                ],
                "asset":null
            },
            "finishLine2":{
                'key':'finishLine2',
                "path": [
                    'https://www.jimmysarcade.co.uk/models/finish2.glb'
                ],
                "asset":null
            }
        },
        "textures":{
            
            
            "check_line":{
               'key':'check_line',
                "path": [
                    'https://www.jimmysarcade.co.uk/textures/check_line.png'
                ],
                "asset":null 
            },
            "caramel":{
               'key':'caramel',
                "path": [
                    'https://www.jimmysarcade.co.uk/textures/collectables/caramel.png'
                ],
                "asset":null 
            },
            "mocha":{
               'key':'mocha',
                "path": [
                    'https://www.jimmysarcade.co.uk/textures/collectables/mocha.png'
                ],
                "asset":null 
            },
            "oat275":{
               'key':'oat275',
                "path": [
                    'https://www.jimmysarcade.co.uk/textures/collectables/oat275.png'
                ],
                "asset":null 
            },
            "original275":{
               'key':'original275',
                "path": [
                    'https://www.jimmysarcade.co.uk/textures/collectables/original275.png'
                ],
                "asset":null 
            },
         
            "finishLine":{
                'key':'finishLine',
                "path": [
                    'https://www.jimmysarcade.co.uk/textures/finishLine.jpeg'
                ],
                "asset":null
            }
        },
        "sounds":{
            
            "cheer":{
                'key':'cheer',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/cheer.mp3'
                ],
                "asset":null
            },
            "FinishLine":{
                'key':'FinishLine',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/FinishLine.mp3'
                ],
                "asset":null
            },
            "Go":{
                'key':'Go',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/go.mp3'
                ],
                "asset":null
            },
            "Invincible":{
                'key':'Invincible',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/Invincible.mp3'
                ],
                "asset":null
            },
            "SpeedBoost":{
                'key':'SpeedBoost',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/SpeedBoost.mp3'
                ],
                "asset":null
            },
            "click":{
                'key':'click',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/click.mp3'
                ],
                "asset":null
            },
            "select":{
                'key':'select',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/select.mp3'
                ],
                "asset":null
            },
            "count":{
                'key':'count',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/count.mp3'
                ],
                "asset":null
            },
            "TimeBoost01":{
                'key':'TimeBoost01',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/TimeBoost01.mp3'
                ],
                "asset":null
            },
            "Hit":{
                'key':'Hit',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/hit.mp3'
                ],
                "asset":null
            },
            "TimeBoost02":{
                'key':'TimeBoost02',
                "path": [
                    'https://www.jimmysarcade.co.uk/sounds/TimeBoost02.mp3'
                ],
                "asset":null
            }
        }
        
        
        
        
        
        
    }
}
export{
    Global
}